<template>
  <v-row>  
    <v-col lg="12" class="page-title">      
      <v-card class="mx-auto mb-1" flat>
        <v-card-title>         
          <v-text-field
            hide-details
            v-model="searchText"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            class="grey-lighten-3 ma-2"
            background-color="#FAFAFA"
            outlined
            fieldset="#ddd"            
            @input="debouncedSearch"
            dense
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn  depressed class="white--text" :color="btnColor" :title="btnName" :to="btnRoute"
             v-if="showButton">
              {{ btnName }}
          </v-btn>
        </v-card-title>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PageTitleWithSearch",
  props: ["title", "loading", "data", "search", "btnName", "btnColor", "btnRoute", "btnEnable","btnPermission"],

  data() {
    return {
      searchText: this.search, // Sync prop to local state
      debounceTimeout: null, // Timer for debouncing
    }
  },

  computed: {
    ...mapGetters("auth", ["hasPermission"]),
    showButton() {
      // Only show if enabled and user has permission
      return this.btnEnable && (!this.btnPermission || this.hasPermission(this.btnPermission));
    }
  },

  watch: {
    // Update searchText when the prop changes
    search(newVal) {
      this.searchText = newVal;
    },
  },
  
  methods: {
    debouncedSearch() {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.$emit("searchText", this.searchText.trim()); // Emit after delay
      }, 500); // Adjust debounce delay (500ms is a good default)
    },
  },

  beforeDestroy() {
    clearTimeout(this.debounceTimeout);
},

};

</script>
<style>
.page-title .v-card__title {
  padding: 0;
  padding-left: 15px;
  padding-right: 15px;
}


</style>
